import httpInstance from "../utils/httpInstance";
import { IS_DEMO_MODE } from "../constants";
import * as demoResponses from "../demo/responses";

export class ConfigApi {
    constructor(baseURL = `https://api.clubrare.wolfelabs.tech/api/v1/configs`) {
        this.instance = httpInstance({
            baseURL,
            timeout: 15000
        })

        this.defaultConfig = {
            headers: {
                "Content-Type": "application/json"
            }
        }

    }

    getBanner(config = this.defaultConfig) {
        if (IS_DEMO_MODE) return demoResponses.getBanner();
        return this.instance.get(`/banner`, config);
    }

}

const configHandler = new ConfigApi();

export default configHandler;
